const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();

export const isSentryConfigured = Boolean(dsn);

type SentryModule = typeof import("@sentry/react");

let sentryReady: Promise<SentryModule | null> | null = null;

/**
 * Load monitoring outside the initial application chunk. Calling this during
 * bootstrap still starts Sentry as early as possible, while installations
 * without a DSN download no monitoring code at all.
 */
function loadSentry(): Promise<SentryModule | null> {
  if (!isSentryConfigured) return Promise.resolve(null);
  sentryReady ??= import("@sentry/react")
    .then((Sentry) => {
      Sentry.init({
        dsn,
        environment: import.meta.env.MODE,
      });
      return Sentry;
    })
    .catch((error: unknown) => {
      sentryReady = null;
      if (import.meta.env.DEV) {
        console.warn("[lexibit] Sentry failed to initialize:", error);
      }
      return null;
    });
  return sentryReady;
}

export function initSentry(): void {
  void loadSentry();
}

export function captureSentryException(
  error: unknown,
  context?: Parameters<SentryModule["captureException"]>[1],
): void {
  void loadSentry().then((Sentry) => {
    Sentry?.captureException(error, context);
  });
}
